import { useState } from "react";
import { Undo2 } from "lucide-react";
import { Button } from "@/components/ui/Button";

/** Skutek uboczny cofnięcia z danego etapu — ten sam dla mapy zasadniczej, wypisów
 *  i MPZP, bo wszystkie trzy trzymają te same pola (sent_*, received_*, fee). */
const DEFAULT_HINTS: Record<string, string> = {
  sent: "data i osoba wysyłki zostaną wyczyszczone",
  received: "data i osoba odbioru zostaną wyczyszczone",
  fee_paid: "opłata urzędowa zostanie odpięta od wniosku (sama opłata zostaje w /official-fees)",
};

/**
 * Cofnięcie zamówienia urzędowego o JEDEN etap. Cel i etykietę liczy backend
 * (`revert_to` / `revert_label`), więc przycisk nie powiela reguł cyklu życia —
 * pokazuje się dokładnie wtedy, gdy jest co cofać.
 */
export function OrderRevertControl({
  status,
  revertTo,
  revertLabel,
  statusLabels,
  hints,
  pending,
  onRevert,
}: {
  status: string;
  /** "" = nie ma czego cofać (przycisk się nie pokazuje). */
  revertTo: string;
  revertLabel: string;
  statusLabels: Record<string, string>;
  /** Dodatkowe zastrzeżenia per status wyjściowy (np. dane wpisane w działki zostają). */
  hints?: Record<string, string>;
  pending: boolean;
  onRevert: (reason: string) => void;
}) {
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState("");

  if (!revertTo) return null;
  const target = statusLabels[revertTo] ?? revertTo;
  const hint = { ...DEFAULT_HINTS, ...hints }[status];

  if (!open) {
    return (
      <Button size="sm" variant="secondary" onClick={() => setOpen(true)}>
        <Undo2 size={13} className="mr-1" /> {revertLabel}
      </Button>
    );
  }
  return (
    <div className="border border-[var(--color-border-strong)] bg-[var(--color-bg-elevated)] p-2 space-y-1.5 text-xs max-w-md">
      <div>
        Zamówienie wróci do statusu <b>„{target}”</b>
        {hint ? ` — ${hint}.` : "."} Zmiana trafi do historii zamówienia.
      </div>
      <input
        className="input-base w-full"
        placeholder="Powód cofnięcia (opcjonalnie)"
        value={reason}
        onChange={(e) => setReason(e.target.value)}
      />
      <div className="flex items-center gap-2">
        <Button size="sm" loading={pending} onClick={() => onRevert(reason.trim())}>
          <Undo2 size={13} className="mr-1" /> {revertLabel}
        </Button>
        <Button
          size="sm"
          variant="ghost"
          onClick={() => {
            setOpen(false);
            setReason("");
          }}
        >
          Anuluj
        </Button>
      </div>
    </div>
  );
}
